import { Component, Input, AfterViewInit, ViewChild, ElementRef, OnDestroy, inject } from '@angular/core';
import { InfoCardComponent } from "../InfoCardComponent/dashboard.component";
import { CommanService } from '../utils/comman.service';
import Chart from 'chart.js/auto';
import { NgClass } from '@angular/common';
import { DashboardService } from '../../services/cng-sails/dashboard/dashboard.service';
import moment from 'moment';

@Component({
  standalone: true,
  selector: 'app-info-card-group',
  templateUrl: './info-card-group.component.html',
  styleUrls: ['./info-card-group.component.scss'],
  imports: [InfoCardComponent, NgClass]
})
export class InfoCardGroupComponent implements AfterViewInit, OnDestroy {
  yesterday = moment()?.subtract(1, 'days').format('YYYY-MM-DD');
  secondHighestDaySale: string = '0';
  secondHighestDaySaleDate: string = '0';
  firstHighestDaySale: string = '0';
  firstHighestDaySaleDate: string = '0';
  dayAfterYesterdaySale: string = '0';
  dayAfterYesterdaySaleDate: string = '0';
  FIFTEENdays: string = '0';
  FIFTEENdaysDate: string = '0';
  getSecondHighestSale(dailyData: { qty: number, date: string }[]): number | null {
    if (!Array.isArray(dailyData) || dailyData.length < 2) return null;
    const sorted = dailyData.slice().sort((a, b) => b.qty - a.qty);
    return sorted[1]?.qty ?? null;
  }
  dashboardService = inject(DashboardService)
  previous7Days: any = '0';
  previous15Days: string = '0';
  HighDayFyi: string = '0';
  TotalHighfyi: string = '0';
  graph15days: any = ['0', '0', '0', '0', '0', '0', '0'];
  graphHighDay: any = ['0', '0', '0', '0', '0', '0', '0'];
  graphTotalHigh: any = ['0', '0', '0', '0', '0', '0', '0'];
  yesterday_percentage_change: string = '0%';
  last_15_days_percentage_change: string = '0%';
  highest_day_percentage_change: string = '0%';
  total_qty_percentage_change: string = '0%';
  yesterday_percentage_change_is_up: boolean = false;
  last_15_days_percentage_change_is_up: boolean = false;
  highest_day_percentage_change_is_up: boolean = false;
  total_qty_percentage_change_is_up: boolean = false;
  today = moment().format('YYYY-MM-DD');
  @Input() chartData1: number[] = [0, 0];
  @Input() chartData2: number[] = [0, 0, 0, 0, 0, 0, 0];
  @Input() chartData3: number[] = [0, 0, 0, 0, 0, 0, 0];
  @Input() chartData4: number[] = [0, 0, 0, 0, 0, 0, 0];

  @ViewChild('miniChart1') miniChartRef1!: ElementRef<HTMLCanvasElement>;
  @ViewChild('miniChart2') miniChartRef2!: ElementRef<HTMLCanvasElement>;
  @ViewChild('miniChart3') miniChartRef3!: ElementRef<HTMLCanvasElement>;
  @ViewChild('miniChart4') miniChartRef4!: ElementRef<HTMLCanvasElement>;

  private chart1: Chart | null = null;
  private chart2: Chart | null = null;
  private chart3: Chart | null = null;
  private chart4: Chart | null = null;

  ngAfterViewInit() {
    // this.createMiniChart(this.miniChartRef1, this.chartData1, chart => this.chart1 = chart,'chartIndex1');
    // this.createMiniChart(this.miniChartRef2, this.chartData2, chart => this.chart2 = chart);
    this.createMiniChart(this.miniChartRef3, this.chartData3, chart => this.chart3 = chart, 'chartIndex3');
    this.createMiniChart(this.miniChartRef4, this.chartData4, chart => this.chart4 = chart, 'chartIndex4');

    this.getTrends();
  }
  private getTrends() {
    this.dashboardService.dashboardTrends().subscribe(res => {
      if (res && res?.code == 200) {
        console.log("res23232", res);
        let highestSales: { sale: number, date: string }[] = [];
        if (Array.isArray(res.data)) {
          res.data.forEach((item: any) => {
            if (typeof item.highest_day_sale === 'number') {
              highestSales.push({ sale: item.highest_day_sale, date: item.highest_day_sale_date });
            }
          });
        }
        highestSales = highestSales.filter((item, index, arr) =>
          arr.findIndex(s => s.sale === item.sale) === index
        );
        highestSales.sort((a, b) => b.sale - a.sale);
        if (highestSales.length > 0) {
          this.firstHighestDaySale = +(highestSales[0].sale / 100000).toFixed(2) + ' lakh';
          this.firstHighestDaySaleDate = moment(highestSales[0].date).format('DD-MM-YYYY');
        }
        if (highestSales.length > 1) {
          this.secondHighestDaySale = +(highestSales[1].sale / 100000).toFixed(2) + ' lakh';
          this.secondHighestDaySaleDate = moment(highestSales[1].date).format('DD-MM-YYYY');
        }
  
        // Find the row with today's date in res.data using moment
        // const data = {
        //   "trend_date": "2025-05-01T00:00:00.000Z",
        //   "total_qty_yesterday": 820000.00,
        //   "total_qty_last_15_days": 19255317.20,
        //   "total_qty_last_15_days_previous": 18455317.20,
        //   "highest_day_sale": 8200000.00,
        //   "highest_day_sale_date": "2025-04-30T00:00:00.000Z",
        //   "total_qty_financial_year": 26655317.20,
        //   "yesterday_percentage_change": 64.0,
        //   "last_15_days_percentage_change": 4.33,
        //   "highest_day_percentage_change": 16.83,
        //   "last_15_days_daily_data": [
        //     { "qty": 300000.00, "date": "2025-04-17" },
        //     { "qty": 290000.00, "date": "2025-04-18" },
        //     { "qty": 310000.00, "date": "2025-04-19" },
        //     { "qty": 275000.00, "date": "2025-04-20" },
        //     { "qty": 7300000.00, "date": "2025-04-21" },
        //     { "qty": 5100000.00, "date": "2025-04-22" },
        //     { "qty": 950000.00, "date": "2025-04-23" },
        //     { "qty": 370000.00, "date": "2025-04-24" },
        //     { "qty": 280000.00, "date": "2025-04-25" },
        //     { "qty": 265000.00, "date": "2025-04-26" },
        //     { "qty": 285000.00, "date": "2025-04-27" },
        //     { "qty": 295000.00, "date": "2025-04-28" },
        //     { "qty": 305000.00, "date": "2025-04-29" },
        //     { "qty": 8200000.00, "date": "2025-04-30" }
        //   ]
        // };
        const data = res.data.find((item: any) => {
          const trendDate = moment(item.trend_date).format('YYYY-MM-DD');
          return trendDate === this.today;
        })
         const data1 = res.data.find((item: any) => {
          const trendDate = moment(item.trend_date).format('YYYY-MM-DD');
          return trendDate === this.today;
        });
        this.FIFTEENdays =  data1?.total_qty_last_15_days_previous ? +(data1?.total_qty_last_15_days_previous / 100000).toFixed(2) + ' lakh' : '0';
        const sortedEntries = data1?.last_15_days_daily_data
          ?.slice()
          ?.sort((a: any, b: any) => moment(a.date).valueOf() - moment(b.date).valueOf());
        const secondLastEntry = sortedEntries?.length > 1 ? sortedEntries[sortedEntries.length - 2] : null;
          this.dayAfterYesterdaySale = secondLastEntry ? +(secondLastEntry.qty / 100000).toFixed(2) + ' lakh' : '0';
          this.dayAfterYesterdaySaleDate = secondLastEntry ? moment(secondLastEntry.date).format('DD-MM-YYYY') : '0';
        if (!data) return;

        this.previous7Days = +(data.total_qty_yesterday / 100000).toFixed(2);
        this.previous15Days = +(data.total_qty_last_15_days / 100000).toFixed(2) + ' lakh';
        this.HighDayFyi = +(data.highest_day_sale / 100000).toFixed(2) + ' lakh';
        this.TotalHighfyi = +(data.total_qty_financial_year / 100000).toFixed(2) + ' lakh';
        this.graph15days = data.last_15_days_daily_data.map((item: any) => (item.qty / 100000).toFixed(2));
        let top3Recentqty = data?.last_15_days_daily_data
          ?.sort((a: any, b: any) => moment(b.date).valueOf() - moment(a.date).valueOf())
          ?.slice(0, 3)
          ?.map((item: any) => Number((item.qty / 100000).toFixed(2)))?.reverse();
        this.yesterday_percentage_change = '0%';
        if (top3Recentqty && top3Recentqty.length >= 3 && top3Recentqty[2] !== 0) {
          const diff = top3Recentqty[2] - top3Recentqty[1];
          const maxVal = Math.max(top3Recentqty[2], top3Recentqty[1]);
          const percent = (diff / maxVal) * 100;
          this.yesterday_percentage_change = `${percent?.toFixed(2)}%`;
        }
        this.createMiniChart(this.miniChartRef2, this.graph15days, chart => this.chart2 = chart, 'chartIndex2');
        this.createMiniChart(this.miniChartRef1, top3Recentqty.map(Number), chart => this.chart1 = chart, 'chartIndex1');
        this.last_15_days_percentage_change = data?.last_15_days_percentage_change != null ? Math.round(data.last_15_days_percentage_change) + '%' : '0%';
        this.highest_day_percentage_change = data?.highest_day_percentage_change != null ? Math.round(data.highest_day_percentage_change) + '%' : '0%';
      }
    });
  }

  private createMiniChart(ref: ElementRef<HTMLCanvasElement>, data: number[], setChart: (chart: Chart) => void, chartType: string = '') {
    if (!ref) return;
    const ctx = ref.nativeElement.getContext('2d');
    if (!ctx) return;

    // Determine trend: up (green) or down (red)
    const highestValue = Math.max(...data);
    const lastValue = data[data.length - 1];
    const isUp = lastValue >= highestValue;
    switch (chartType) {
      case 'chartIndex1':
        this.yesterday_percentage_change_is_up = isUp;
        console.log("yesterday_percentage_change_is_up", this.yesterday_percentage_change_is_up);
        break;
      case 'chartIndex2':
        this.last_15_days_percentage_change_is_up = isUp;
        break;
      case 'chartIndex3':
        this.highest_day_percentage_change_is_up = isUp;
        break;
      case 'chartIndex4':

        // this.total_qty_percentage_change_is_up = isUp;
        break;
      default:
        this.graphTotalHigh = data.map((item: any) => (item.qty / 100000).toFixed(2));
    }
    const borderColor = isUp ? '#16a34a' : '#dc2626';
    const backgroundColor = isUp ? 'rgba(22,163,74,0.08)' : 'rgba(220,38,38,0.08)';

    const chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: data.map(() => ''),
        datasets: [{
          data,
          borderColor,
          backgroundColor,
          borderWidth: 1,
          pointRadius: 0,
          fill: true,
          tension: 0.10,
        }]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true },
          title: { display: false },
          datalabels: { display: false } // Hide data labels
        },
        scales: {
          x: {
            display: false,
            grid: { display: false },
            ticks: { display: false }
          },
          y: {
            display: false, // Hide Y axis
            grid: { display: false }, // Hide Y gridlines
            ticks: { display: false }
          }
        },
        elements: {
          line: { borderCapStyle: 'round' }
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 20,
            right: 10,
            bottom: 12,
            left: 10
          },
          autoPadding: true
        }
      }
    });

    setChart(chart);
  }

  ngOnDestroy() {
    this.chart1?.destroy();
    this.chart2?.destroy();
    this.chart3?.destroy();
  }
}
